// TODO: Come up with more robust way of generating key for the report in Redux.
//       The tricky part is distinguishing between pagination parameters which
//       only cause additional data to be fetched for a given report, and other
//       parameters (i.e. sort, filter) which cause different data to be returned
//       for the report.

import {get, isUndefined} from 'lodash';

export const getCacheKey = ({recordsName, recordsParams, filtersData}: any) => {
  if (isUndefined(recordsParams)) {
    return recordsName;
  }
  const sortBy = recordsParams?.[0]?.sortBy || '';
  const sortOrder = recordsParams?.[0]?.sortOrder || '';
  const filterBy = get(recordsParams, 'filterBy', 'default');
  const filterByValue =
    recordsParams && recordsParams.length > 0
      ? recordsParams.map((param: any) => param?.filterByValue ?? '').join('_')
      : '';

  const level = filtersData?.level || '';
  const products = filtersData?.products || '';
  const accountStatus = filtersData?.accountStatus || '';

  const period =
    typeof filtersData?.period === 'object'
      ? filtersData.period.value
      : filtersData?.period ?? '';
  const rank = '';
  const fibc = filtersData?.fibc || '';
  const frontline = filtersData?.frontline || '';
  const cabEarned = filtersData?.cabEarned ? 'cabEarned' : '';
  const aabEarned = filtersData?.aabEarned ? 'aabEarned' : '';
  const closeToNextRank = filtersData?.closeToNextRank || '';
  const fqvMin = filtersData?.fqvMin ?? '';
  const fqvMax = filtersData?.fqvMax ?? '';
  const newClientsAbove = filtersData?.newClientsAbove ?? '';
  const newClientsBelow = filtersData?.newClientsBelow ?? '';
  const qualifiedClientsAbove = filtersData?.qualifiedClientsAbove ?? '';
  const qualifiedClientsBelow = filtersData?.qualifiedClientsBelow ?? '';
  const newCoachesAbove = filtersData?.newCoachesAbove ?? '';
  const newCoachesBelow = filtersData?.newCoachesBelow ?? '';

  const reportFilters = filtersData
    ? level + products + accountStatus ||
      rank +
        period +
        fibc +
        frontline +
        cabEarned +
        aabEarned +
        closeToNextRank +
        fqvMin +
        fqvMax +
        newClientsAbove +
        newClientsBelow +
        qualifiedClientsAbove +
        qualifiedClientsBelow +
        newCoachesAbove +
        newCoachesBelow
    : 'Filters-N/A';
  return `${recordsName}-${sortBy}-${sortOrder}-${filterBy}-${filterByValue}-${reportFilters}`;
};

// TODO: Currently we assume the first record parameter is the record's ID.
//       Going forward we should come up with a more robust way to serializing
//       all record parameters to generate the record cache key.
export const getRecordCacheKey = ({reportKey, recordParams}: any) => {
  return `${reportKey}/${recordParams[0]}`;
};
